import { PRE_APPROVAL_REQUEST_RECEIVED, PRE_APPROVAL_REQUEST_ERROR } from '../actions/account/account-action-types';

const preApproval = (state = null, action) => {
  switch (action.type) {
    case PRE_APPROVAL_REQUEST_RECEIVED:
      return action.payload;
    case PRE_APPROVAL_REQUEST_ERROR:
      return null;
    default:
      return state;
  }
};

export default preApproval;
